import React from "react";
import Sharebutton from "./Sharebuttons";


export default function ShareUs(){
    return (
        <div className="maincontent maindiv" >
            <Sharebutton to="Someone" message="Hey Checkout This amazing website !" />
        </div>
    )
}